import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { IndicatorComponent } from './indicator/indicator.component';
import { OnBehalfIndicatorComponent } from './on-behalf-indicator/on-behalf-indicator.component';
import { CertemyCommonModule } from 'common/certemy-common.module';

const components = [IndicatorComponent, OnBehalfIndicatorComponent];

@NgModule({
  imports: [CertemyCommonModule, NgbTooltipModule],
  exports: components,
  declarations: components,
})
export class IndicatorsModule {}
